import { render } from "./PlansForm.vue?vue&type=template&id=9858575c&scoped=true"
import script from "./PlansForm.vue?vue&type=script&lang=js"
export * from "./PlansForm.vue?vue&type=script&lang=js"

import "./PlansForm.vue?vue&type=style&index=0&id=9858575c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9858575c"]])

export default __exports__